import React from "react";
import shell from "./extension-page-shell.module.css";
import {
  DUMMY_CART_ITEM,
  DUMMY_CUSTOMER,
  DUMMY_ORDER_TOTALS,
  formatCustomerAddress,
} from "./extension-preview-dummy-data";

export function ExtensionOrderSummarySidebar({ variant = "checkout" }) {
  const showGiftCard = variant === "checkout";

  return (
    <aside className={shell.sidebarPane}>
      <div className={shell.sidebarInner}>
        <div className={shell.sidebarCard}>
          <div className={shell.sidebarItem}>
            <div className={shell.sidebarThumb}>
              <span className={shell.sidebarBadge}>1</span>
            </div>
            <div className={shell.sidebarItemBody}>
              <p className={shell.sidebarItemTitle}>{DUMMY_CART_ITEM.title}</p>
              <p className={shell.sidebarItemPrice}>{DUMMY_CART_ITEM.price}</p>
            </div>
          </div>

          {showGiftCard ? (
            <div className={shell.giftCardRow}>
              <div className={shell.giftCardInput}>Discount code or gift card</div>
              <button type="button" className={shell.giftCardBtn}>
                Apply
              </button>
            </div>
          ) : null}

          <div className={shell.sidebarRow}>
            <span>Subtotal</span>
            <span>{DUMMY_ORDER_TOTALS.subtotal}</span>
          </div>
          <div className={shell.sidebarRow}>
            <span>Shipping</span>
            <span>{DUMMY_ORDER_TOTALS.shipping}</span>
          </div>
          <div className={shell.sidebarRow}>
            <span>Estimated taxes</span>
            <span>{DUMMY_ORDER_TOTALS.taxes}</span>
          </div>
          <div className={shell.sidebarTotal}>
            <span>Total</span>
            <span>{DUMMY_ORDER_TOTALS.total}</span>
          </div>
        </div>
      </div>
    </aside>
  );
}

export function ExtensionOrderStatusSidebar() {
  return (
    <aside className={shell.sidebarPane}>
      <div className={shell.sidebarInner}>
        <div className={shell.sidebarDueCard}>
          <div className={shell.sidebarRow}>
            <span>Payment due</span>
            <strong>{DUMMY_ORDER_TOTALS.total.replace("INR ", "")}</strong>
          </div>
          <div className={shell.sidebarDueItem}>
            <div className={shell.sidebarItem}>
              <div className={shell.sidebarThumb} />
              <div className={shell.sidebarItemBody}>
                <p className={shell.sidebarItemTitle}>{DUMMY_CART_ITEM.title}</p>
                <p className={shell.sidebarItemPrice}>{DUMMY_CART_ITEM.price}</p>
              </div>
            </div>
          </div>
          <div className={shell.sidebarTotal}>
            <span>Due</span>
            <span>{DUMMY_ORDER_TOTALS.total.replace("INR ", "")}</span>
          </div>
          <button type="button" className={shell.sidebarPayBtn}>
            Pay now
          </button>
        </div>
      </div>
    </aside>
  );
}

export function CheckoutPageSkeleton() {
  const customer = DUMMY_CUSTOMER;

  return (
    <>
      <section className={shell.sectionBlock}>
        <h2 className={shell.sectionHeading}>Contact</h2>
        <input
          readOnly
          className={shell.fieldInput}
          value={customer.email}
          aria-label="Email"
        />
      </section>

      <section className={shell.sectionBlock}>
        <h2 className={shell.sectionHeading}>Delivery</h2>
        <div className={shell.fieldRow}>
          <input readOnly className={shell.fieldInput} value={customer.firstName} />
          <input readOnly className={shell.fieldInput} value={customer.lastName} />
        </div>
        <input readOnly className={shell.fieldInput} value={customer.address1} />
        <input readOnly className={shell.fieldInput} value={customer.address2} />
        <div className={shell.fieldRow}>
          <input readOnly className={shell.fieldInput} value={customer.city} />
          <input readOnly className={shell.fieldInput} value={customer.zip} />
        </div>
        <div className={shell.fieldRow}>
          <input readOnly className={shell.fieldInput} value={customer.country} />
          <input readOnly className={shell.fieldInput} value={customer.state} />
        </div>
      </section>

      <section className={shell.sectionBlock}>
        <h2 className={shell.sectionHeading}>Shipping method</h2>
        <div className={shell.shippingMethodBox}>
          <div>
            <p className={shell.shippingMethodTitle}>Standard shipping</p>
            <p className={shell.shippingMethodMeta}>3–5 business days</p>
          </div>
          <strong>{DUMMY_ORDER_TOTALS.shipping}</strong>
        </div>
      </section>

      <button type="button" className={shell.continueBtnGhost}>
        Continue to payment
      </button>
    </>
  );
}

export function ThankYouPageSkeleton() {
  const customer = DUMMY_CUSTOMER;
  const address = formatCustomerAddress(customer);

  return (
    <>
      <section className={shell.confirmedBox}>
        <p className={shell.confirmedTitle}>Your order is confirmed</p>
        <p className={shell.confirmedText}>
          You&apos;ll receive a confirmation email soon
        </p>
      </section>

      <section className={shell.orderDetailsCard}>
        <h2 className={shell.orderDetailsTitle}>Order details</h2>
        <div className={shell.orderDetailsGrid}>
          <div>
            <p className={shell.orderDetailsLabel}>Contact information</p>
            <p className={shell.orderDetailsValue}>{customer.email}</p>
          </div>
          <div>
            <p className={shell.orderDetailsLabel}>Payment method</p>
            <p className={shell.orderDetailsValue}>Credit card</p>
          </div>
          <div>
            <p className={shell.orderDetailsLabel}>Shipping address</p>
            <p className={shell.orderDetailsValue}>{address}</p>
          </div>
          <div>
            <p className={shell.orderDetailsLabel}>Billing address</p>
            <p className={shell.orderDetailsValue}>{address}</p>
          </div>
        </div>
      </section>
    </>
  );
}

export function OrderStatusPageSkeleton() {
  return (
    <div className={shell.stackSection}>
      <section className={shell.timelineCard}>
        <div className={shell.timelineIcon} />
        <div className={shell.timelineBody}>
          <p className={shell.timelineTitle}>Return in progress</p>
          <p className={shell.timelineText}>
            Your request was approved. Print your return shipping label and attach
            it to the package containing your return items.
          </p>
        </div>
      </section>
      <section className={shell.timelineCard}>
        <div className={shell.timelineIcon} />
        <div className={shell.timelineBody}>
          <p className={shell.timelineTitle}>Arrived 7 Jun</p>
          <p className={shell.timelineText}>Delivered — New Delhi, India</p>
        </div>
      </section>
      <section className={shell.timelineCard}>
        <div className={shell.timelineIcon} />
        <div className={shell.timelineBody}>
          <p className={shell.timelineTitle}>Confirmed</p>
          <p className={shell.timelineText}>
            We&apos;re preparing these items for shipping.
          </p>
        </div>
      </section>
    </div>
  );
}

export { shell as pageShellStyles };
